export const AUTHENTICATED = "AUTHENTICATED";
export const LOGOUT = "LOGOUT";
export const OPEN_PROFILE_SIDEBAR = "OPEN_PROFILE_SIDEBAR";
export const CLOSE_PROFILE_SIDEBAR = "CLOSE_PROFILE_SIDEBAR";
export const OPEN_NEWCHAT_SIDEBAR = "OPEN_NEWCHAT_SIDEBAR";
export const CLOSE_NEWCHAT_SIDEBAR = "CLOSE_NEWCHAT_SIDEBAR";
export const OPEN_SELECTED_CHAT = "OPEN_SELECTED_CHAT";
export const UPDATE_SELECTED_CHAT = "UPDATE_SELECTED_CHAT";
export const CHANGE_PROFILE_URL = "CHANGE_PROFILE_URL";
export const SET_CONVERSATION_ID = "SET_CONVERSATION_ID";
export const OPEN_RIGHT_SIDEBAR = "OPEN_RIGHT_SIDEBAR";
export const CLOSE_RIGHT_SIDEBAR = "CLOSE_RIGHT_SIDEBAR";
export const SET_THEME = "SET_THEME";
export const TOGGLE_THEME = "TOGGLE_THEME";
export const SET_CONVERSATIONS = "SET_CONVERSATIONS";
